import { defineNuxtPlugin } from 'nuxt/app'

const WARNINGS_TO_SUPPRESS = [
  'Property "$style" was accessed during render but is not defined on instance.',
]

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.warnHandler = (msg, instance, trace) =>
    !WARNINGS_TO_SUPPRESS.includes(msg) &&
    console.warn('[Vue warn]: '.concat(msg).concat(trace))
})
